import { GET } from "../../../services/api";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import { clientTypes } from "../../type/clientTypes";

export const fetchDashboardData = (key, url, params = {}) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.DASHBOARD_DATA_PENDING,
        key,
      });

      const query = new URLSearchParams(params).toString();
      const res = await GET(`${url}${query ? `?${query}` : ""}`);

      dispatch({
        type: clientTypes.DASHBOARD_DATA_SUCCESS,
        key,
        payload: res.data?.result ?? [],
        msg: res.data?.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.DASHBOARD_DATA_FAILED,
        key,
        payload: [],
        msg: error?.message ?? "Something went wrong",
      });
    }
  };
};

export const getDashboardCount = () =>
  fetchDashboardData("count", ApiUrl.CLIENT_DASHBOARD_COUNT_GET);

export const getDashboardPieChart = () =>
  fetchDashboardData("pieChart", ApiUrl.CLIENT_DASHBOARD_PIE_CHART_DATA_GET);

export const getTop10Listeners = () =>
  fetchDashboardData("top10Listeners", ApiUrl.CLIENT_TOP_10_LISTENERS_GET);

export const getTop100MostListened = (params) =>
  fetchDashboardData(
    "top100MostListened",
    ApiUrl.CLIENT_TOP_100_MOST_LISTENED_GET,
    params
  );

export const getTop100LeastListened = (params) =>
  fetchDashboardData(
    "top100LeastListened",
    ApiUrl.CLIENT_TOP_100_LEAST_LISTENED_GET,
    params
  );

export const getPodcastListeners = (params) =>
  fetchDashboardData(
    "podcastListeners",
    ApiUrl.CLIENT_PODCAST_LISTENERS_GET,
    params
  );

export const getPodcastCategoryWise = (params) =>
  fetchDashboardData(
    "podcastCategoryWise",
    ApiUrl.CLIENT_PODCAST_CATEGORY_WISE_LISTENERS_GET,
    params
  );
